import React from 'react';  
import './index.css';
 
import { Icon,Tag } from 'antd-mobile';
import IconChoose from './img/icon_choose.png';
class SelectBar extends React.Component{
  constructor(props) {
        super(props);
        this.state = {
            index: 0,
            selected: true
        }
    }

  handleChange = (selected,index,type) => {
      this.setState({ selected, index });
      this.sortChange(type)
  }
  handleClick(){
      this.props.open()
  }
 
  sortChange(type){
    this.props.getSelectList(type)
   // click_record_num热度,updated_at时间,learn_record_num学习
      //console.log(type)
  }
  render(){
    return (
      <div className="select-bar">
        <div className="select-bar-left">
          <Tag className="select-item"
               selected={this.state.selected&&this.state.index===0}
               onChange={selected => this.handleChange( selected,0,'')}>
              <span>综合</span>
          </Tag>
          <Tag  className="select-item" onClick={()=>{this.sortChange()}}
                selected={this.state.selected&&this.state.index===1}
                onChange={selected => this.handleChange( selected,1,'updated_at')}>   
                <span>时间</span>
                <Icon type="down" size="xxs"/>
          </Tag>
            
             {/*<Tag  className="select-item" onClick={()=>{this.sortChange()}}*/}
                {/*selected={this.state.selected&&this.state.index===2}*/}
                {/*onChange={selected => this.handleChange( selected,2,'learn_record_num')}>   */}
                {/*<span>学习</span>*/}
                {/*<Icon type="down" size="xxs"/>*/}
          {/*</Tag>*/}
            <Tag  className="select-item" onClick={()=>{this.sortChange()}}
                selected={this.state.selected&&this.state.index===3}
                onChange={selected => this.handleChange( selected,3,'click_record_num')}>   
                <span>热度</span>
                <Icon type="down" size="xxs"/>
          </Tag>
        </div>
        <div className="select-bar-right" onClick={()=>{this.handleClick()}}>
          <span>筛选</span>
          <img src={IconChoose} className="icon_choose"/>
        </div>
      </div>
      )
  }
}

export default SelectBar;

 